export default __webpack_public_path__ + "static/media/deliland-wheat-icon.b6b9fb4e.png";